<template>
  <div class="ec-line027">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: $routePage.EC_LINE009 }"> {{ $t('ec-line009.heading') }}</el-breadcrumb-item>
      <el-breadcrumb-item> {{ $t('ec-line027.heading') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <address-list
      v-loading="loading"
      :data="items"
      v-model="address_default"
      :submit="submit"
      :cancel="cancel"
      :submit-text="$t('ec-line027.content.updateDefaultAddressBtn')"
      :is-ec-line027-flag="true"
      :address-list-checkboxes="addressListCheckboxes"
      :selected-changed="selectedChanged"
      :corporate-flag="corporateFlag"
      @edit-address="onEditAddr"
      @add-address="onNewAddr"
    />

    <prompt-dialog
      :visible.sync="successVisible"
      :title="$t('ec-line027.content.promptTitle')"
      :content="$t('ec-line027.content.promptContent')"
      @on-cancel="successVisible = false"
    />
  </div>
</template>

<script>
import { AddressService } from '@/services'
import BreadcrumbMixin from '@/mixins/breadcrumb'
import { PROVIDER } from '@/constants'
import AddressList from '@/components/AddressList.vue'
import PromptDialog from '@/components/PromptDialog.vue'

export default {
  components: { AddressList, PromptDialog },
  mixins: [BreadcrumbMixin],
  data() {
    return {
      items: [],
      address_default: null,
      loading: false,
      successVisible: false,
      initialAddressId: null,
      addressListCheckboxes: {
        is_update_customer: false,
      },
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    selectedChanged() {
      return this.addressIdJustAfterUpSert ? true : this.initialAddressId !== this.address_default
    },
    addressIdJustAfterUpSert() {
      return this.$store.getters['addressUpsert/getAddressIdJustAfterUpSert']
    },
    corporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
  },
  methods: {
    async fetchData() {
      this.loading = true
      const { data } = await AddressService.getListAddress()
      this.items = data
      if (this.addressIdJustAfterUpSert) {
        this.address_default = this.addressIdJustAfterUpSert
      } else {
        this.address_default = this.items.find((i) => i.is_default)?.id
      }
      this.initialAddressId = this.address_default
      this.loading = false
    },
    submit(selected) {
      this.loading = true
      if (!this.addressListCheckboxes.is_update_customer) {
        AddressService.setDefaultAddress(selected)
          .then(() => (this.successVisible = true))
          .catch((error) => this.handleError(error))
          .finally(() => (this.loading = false))
        // .then(() => this.$alert({ message: this.$t('ec-line027.content.updateAdressSucces'), type: 'success' }))
      } else {
        const cusInfo = this.items.find((addr) => addr.id === selected)

        const form = {
          name01: cusInfo.name01,
          name02: cusInfo.name02,
          kana01: cusInfo.kana01,
          kana02: cusInfo.kana02,
          postal_code: cusInfo.postal_code,
          addr01: cusInfo.addr01,
          addr02: cusInfo.addr02,
          addr03: cusInfo.addr03,
          phone_number: cusInfo.phone_number,
          pref_id: cusInfo.pref.id,
          customer_status011: this.user.customer_status_id,
          is_update_customer: true,
          is_default: true,
        }

        AddressService.updateAddress(selected, form)
          .then(() => {
            this.successVisible = true
            this.$store.dispatch('auth/getAuth', { provider: PROVIDER.CUSTOMER })
            this.$store.commit('addressUpsert/resetAddressId')
          })
          .catch((error) => this.handleError(error))
          .finally(() => (this.loading = false))
      }
    },
    cancel() {
      this.$store.commit('addressUpsert/resetAddressId')
      this.$router.back()
    },
    onEditAddr(id) {
      this.$router.push({
        name: 'EC_LINE011_UPDATE',
        params: { id },
      })
    },
    onNewAddr() {
      this.$router.push({
        name: 'EC_LINE011_NEW',
      })
    },
  },
  metaInfo() {
    return {
      title: this.$t('ec-line027.title'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('ec-line027.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('ec-line027.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>
<style lang="scss">
.section__body {
  .el-radio {
    width: 100%;
    margin-right: 0;
    &__label {
      width: 100%;
    }
  }
}
</style>
